import { NextResponse } from "next/server";

// Define paths that should show "Coming Soon"
const comingSoonPaths = [ "/careers", "/news", "/media-kit", "/awards","/contracts","/inventory","/product-catalogue","/care","/cvm","/teleco-crm","/company",];

export function middleware(req) {
  const { pathname } = req.nextUrl;

  if (comingSoonPaths.includes(pathname)) {
    return NextResponse.redirect(new URL("/coming-soon", req.url));
  }

  return NextResponse.next();
}

export const config = {
  matcher: "/:path*", // Apply middleware to all paths
};
